import isHtmlElementNode from '@atlas/tool/box/dom/isHtmlElementNode';
import isTextHtmlElement, { type TTextHtmlElement } from '@atlas/tool/box/dom/isTextHtmlElement';
import isVoidHtmlElement, { type TVoidHtmlElement } from '@atlas/tool/box/dom/isVoidHtmlElement';
import isListHtmlElement, { type TListHtmlElement } from '@atlas/tool/box/dom/isListHtmlElement';

export default function isNodeBreakingElement(
    node: Node,
): node is
    | TTextHtmlElement
    | TVoidHtmlElement
    | TTableHtmlElement
    | TListHtmlElement
    | TListItemHtmlElement
    | TTableCellHtmlElement {
    return (
        isHtmlElementNode(node) &&
        (isTextHtmlElement(node) ||
            isVoidHtmlElement(node) ||
            isListHtmlElement(node) ||
            isHtmlElementNode(node, 'BR') ||
            isHtmlElementNode(node, 'TABLE') ||
            isHtmlElementNode(node, 'LI') ||
            isHtmlElementNode(node, 'TD') ||
            isHtmlElementNode(node, 'TH'))
    );
}

// #region Types

type TListItemHtmlElement = HTMLLIElement & { tagName: 'LI' };
type TTableHtmlElement = HTMLTableElement & { tagName: 'TABLE' };
type TTableCellHtmlElement = HTMLTableCellElement & { tagName: 'TD' | 'TH' };

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('isNodeBreakingElement', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
